export function clone (obj = {}) {
  return JSON.parse(JSON.stringify(obj))
}
export function convertSelect (arr = []) {
  return arr.map(entry => {
    return Object.keys(entry).reduce((obj, key) => {
      const value = entry[key]
      if (key === 'id') key = 'value'
      if (key === 'nome') key = 'label'
      obj[key] = value
      return obj
    }, {})
  })
}

export function convertSelectBanco (arr = []) {
  return arr.map(entry => {
    return Object.keys(entry).reduce((obj, key) => {
      let value = entry[key]
      if (key === 'id') key = 'value'
      if (key === 'nome') {
        key = 'label'
        value = entry['cod'] + ' - ' + value
      }
      obj[key] = value
      return obj
    }, {})
  })
}
export function convertSelectRegra (arr = []) {
  return arr.map(entry => {
    return Object.keys(entry).reduce((obj, key) => {
      let value = entry[key]
      if (key === 'id') key = 'value'
      if (key === 'nome') {
        key = 'label'
        value = entry['id'] + ' - ' + value
      }
      obj[key] = value
      return obj
    }, {})
  })
}

export function convertSelectCidade (arr = []) {
  return arr.map(entry => {
    return Object.keys(entry).reduce((obj, key) => {
      let value = entry[key]
      if (key === 'id') key = 'value'
      if (key === 'nome') {
        key = 'label'
        value += ' / ' + entry['uf']
        obj['nome'] = entry['nome']
      }
      obj[key] = value
      return obj
    }, {})
  })
}

export function extractSelect (arr = []) {
  return arr.map(entry => {
    return Object.keys(entry).reduce((obj, key) => {
      const value = entry[key]
      if (key === 'value') key = 'id'
      if (key === 'label') key = 'nome'
      obj[key] = value
      return obj
    }, {})
  })
}



// WEBPACK FOOTER //
// ./src/service/collection.js